import clsx from "clsx";
import React from "react";
import { toDataTestIdSlug } from "@/utils/dataTestId";

const BtnGroup = ({
  buttons,
  selectedValue,
  onClick,
  className,
  testIdPrefix,
}) => {
  return (
    <div
      className={clsx(
        "rounded-md overflow-hidden border border-[#69a4ce] flex",
        className
      )}
    >
      {buttons.map((btn, index) => (
        <button
          key={btn.value}
          className={clsx(
            "text-sm py-2 px-4 border-[#69a4ce] flex-1 text-nowrap",
            {
              "bg-[#69a4ce] text-white": btn.value === selectedValue,
              "border-x": index !== 0 && index !== buttons.length - 1,
            }
          )}
          onClick={btn.onClick ? btn.onClick : () => onClick(btn.value)}
          data-testid={`${testIdPrefix}-${toDataTestIdSlug(btn.value || btn.label || index)}-btn`}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};

export default BtnGroup;
